// Original premium colors
const baseColorsList = ["#3ABEF9", "#E1AFD1", "#FFBB70", "#FFB38E"];

export default function generateRandomColors(count, baseColors = baseColorsList) {
  // Handle edge cases
  if (count <= 0) return [];
  if (count <= baseColors.length) return baseColors.slice(0, count);
  
  // Function to lighten a color
  const lightenColor = (hex, percentage) => {
    // Remove # if present
    hex = hex.replace('#', '');
    
    // Convert hex to RGB
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    
    // Lighten the color
    const lighten = (color) => Math.min(255, color + (255 - color) * percentage);
    
    const lightR = Math.round(lighten(r));
    const lightG = Math.round(lighten(g));
    const lightB = Math.round(lighten(b));
    
    // Convert back to hex
    return `#${lightR.toString(16).padStart(2, '0')}${lightG.toString(16).padStart(2, '0')}${lightB.toString(16).padStart(2, '0')}`;
  };
  
  // Base colors to start with
  let uniqueColors = [...baseColors];
  
  // Lighten percentages
  const lightenPercentages = [0.3, 0.5, 0.7, 0.85];
  
  // Generate additional light variations
  let attempts = 0;
  const maxAttempts = baseColors.length * lightenPercentages.length;
  
  for (const baseColor of baseColors) {
    for (const percentage of lightenPercentages) {
      if (uniqueColors.length >= count) break;
      
      const lightColor = lightenColor(baseColor, percentage);
      
      // Only add if not already in the array
      if (!uniqueColors.includes(lightColor)) {
        uniqueColors.push(lightColor);
      }
      
      attempts++;
      if (attempts >= maxAttempts) break;
    }
    
    if (uniqueColors.length >= count || attempts >= maxAttempts) break;
  }
  
  // If we still don't have enough colors, cycle through existing ones
  if (uniqueColors.length < count) {
    const existing = [...uniqueColors];
    while (uniqueColors.length < count) {
      uniqueColors.push(existing[uniqueColors.length % existing.length]);
    }
  }
  
  return uniqueColors.slice(0, count);
}